const updates = [
  {
    time: '3分钟前',
    title: '某古装剧剧组突发停工，疑似男主角卷入出轨丑闻被资方撤换',
    tag: '突发',
    hot: true,
  },
  {
    time: '18分钟前',
    title: '知名女歌手深夜发文暗示婚变，配图耐人寻味引发粉丝集体猜测',
    tag: '热议',
    hot: true,
  },
  {
    time: '42分钟前',
    title: '选秀节目导演被曝向练习生索要贿赂，节目组紧急发声明否认',
    tag: '爆料',
    hot: false,
  },
  {
    time: '1小时前',
    title: '某顶流男星工作室凌晨发律师函，否认近日所有出轨传闻',
    tag: '回应',
    hot: true,
  },
  {
    time: '2小时前',
    title: '圈内知情人士透露：某综艺节目冠军早已内定，投票环节纯属走形式',
    tag: '内幕',
    hot: false,
  },
  {
    time: '3小时前',
    title: '老牌歌手税务案新进展：检方追加起诉，涉及金额进一步扩大',
    tag: '跟进',
    hot: false,
  },
  {
    time: '4小时前',
    title: '某女团成员恋情实锤？粉丝拍到与神秘男子同游日本照片',
    tag: '实锤',
    hot: true,
  },
  {
    time: '5小时前',
    title: '新生代演员学历门续集：母校老师接受采访透露更多疑点',
    tag: '追踪',
    hot: false,
  },
  {
    time: '6小时前',
    title: '知名导演被拍到深夜出入娱乐场所，同行的多名女艺人身份引关注',
    tag: '吃瓜',
    hot: false,
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新快讯
            </h2>
            <p className="text-foreground-500 text-sm">实时追踪娱乐圈最新动态</p>
          </div>
          <span className="hidden sm:flex items-center gap-1.5 text-xs text-foreground-400">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></span>
            实时更新中
          </span>
        </div>

        <div className="space-y-0">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-3 md:gap-5 py-4 border-b border-background-200/70 last:border-b-0 cursor-pointer hover:bg-background-50/50 transition-colors px-3 -mx-3 rounded"
            >
              <span className="flex-shrink-0 text-xs text-foreground-400 mt-0.5 w-16 whitespace-nowrap">
                {item.time}
              </span>
              <span className={`flex-shrink-0 text-[10px] px-1.5 py-0.5 rounded font-semibold mt-0.5 whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-100 text-primary-700'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {item.tag}
              </span>
              <p className="text-sm text-foreground-800 leading-relaxed flex-1">
                {item.title}
              </p>
              <i className="ri-arrow-right-s-line text-foreground-300 flex-shrink-0 mt-0.5"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}